import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
// import { StrtActivity } from './StrtActivity';
// import { DataUtils } from './data-utils';
import { DataUtils } from '../../shared/utilities/data-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StrtActivity } from '../../shared/models/plan/StrtActivity';

// export interface IActivityDates {
//   activity: StrtActivity;
//   startDate: Date;
//   endDate: Date;
// }

export interface StrtActivityDates {
  activity: StrtActivity;
  startDate: Date;
  endDate: Date;
}

@Injectable()
export class ActivityService {
  private baseUrl = environment.baseUrl;

  public static mapActivityDates(activity: StrtActivity) {
    DataUtils.replaceDatePropertyIfPresent(activity, 'launchDate');
    return activity;
  }

  constructor(private http: HttpClient) { }

  createActivity(activity: StrtActivity): Observable<StrtActivity> {
    return this.http.post(`${this.baseUrl}/strategies/${activity.strategyId}/initiatives/${activity.initiativeId}/activities`,
      this.transformToBody(activity)).pipe(
      map(ActivityService.mapActivityDates));
  }

  updateActivity(activity: StrtActivity): Observable<StrtActivity> {
    return this.http.put(
      `${this.baseUrl}/strategies/${activity.strategyId}/initiatives/${activity.initiativeId}/activities/${activity.activityId}`,
      this.transformToBody(activity)).pipe(
      map(ActivityService.mapActivityDates));
  }

  deleteActivity(activity: StrtActivity): Observable<{}> {
    return this.http.delete(
      `${this.baseUrl}/strategies/${activity.strategyId}/initiatives/${activity.initiativeId}/activities/${activity.activityId}`);
  }

  private transformToBody(activity: StrtActivity) {
    return Object.assign(
      {activityTargetRequestList: activity.activityTargets.map(it => Object.assign({outcome: it.expectedOutcome}, it))}, activity);
  }
}
